import React, { useEffect } from 'react';
import styled from 'styled-components';

import { colors } from 'helpers/ColorHelper';
import { getTranslatedString } from 'helpers/i18n';
import paysafeConfig from 'config/services/paysafe';

var API_KEY = paysafeConfig.apiKey;
var OPTIONS = {
  environment: paysafeConfig.env,
  fields: {
    cardNumber: {
      selector: '#card-number',
      placeholder: 'Card number',
    },
    expiryDate: {
      selector: '#expiration-date',
      placeholder: 'Expiration date',
    },
    cvv: {
      selector: '#cvv',
      placeholder: 'CVV',
    },
  },
  style: {
    input: {
      'font-weight': 'normal',
      'font-family': "'Open Sans' sans-serif",
      'font-size': '14px',
      color: '#595959',
    },
  },
};

const style = {
  base: {
    padding: '1rem',
  },
};

const StyledErrorP = styled.p`
  color: ${colors.YUHU_RED};
`;

export const PaysafeFields = ({
  setPaysafeInstance,
  cardNumberError,
  cvvError,
  expiryDateError,
  setCardNumberError,
  setCvvError,
  setExpiryDateError,
}) => {
  useEffect(
    () => {
      window.paysafe.fields.setup(API_KEY, OPTIONS, (paysafeInstance, error) => {
        if (error) {
          window.Rollbar.error('Setup error: ' + error.code + ' ' + error.detailedMessage);
        } else {
          setPaysafeInstance(paysafeInstance);

          paysafeInstance
            .fields('cvv cardNumber expiryDate')
            .fieldValueChange(function(instance, event) {
              if (event.target.fieldName === 'CardNumber') {
                if (!instance.fields.cardNumber.isValid()) {
                  setCardNumberError(getTranslatedString('tenantPortal.paysafe.invalidCardNumber'));
                } else {
                  setCardNumberError(null);
                }
              } else if (event.target.fieldName === 'Cvv') {
                if (!instance.fields.cvv.isValid()) {
                  setCvvError(getTranslatedString('tenantPortal.paysafe.invalidCVVNumber'));
                } else {
                  setCvvError(null);
                }
              } else if (event.target.fieldName === 'ExpiryDate') {
                setExpiryDateError();
                if (!instance.fields.expiryDate.isValid()) {
                  setExpiryDateError(getTranslatedString('tenantPortal.paysafe.invalidDate'));
                } else {
                  setExpiryDateError(null);
                }
              }
            });

          paysafeInstance.fields('cvv cardNumber expiryDate').valid((instance, event) => {
            if (event.target.fieldName === 'CardNumber') {
              setCardNumberError();
              setCardNumberError(null);
            } else if (event.target.fieldName === 'Cvv') {
              setCvvError();
              setCvvError(null);
            } else if (event.target.fieldName === 'ExpiryDate') {
              setExpiryDateError(null);
            }
          });
          paysafeInstance.fields('cvv cardNumber expiryDate').invalid((instance, event) => {
            if (event.target.fieldName === 'CardNumber') {
              setCardNumberError(getTranslatedString('tenantPortal.paysafe.invalidCardNumber'));
              setCardNumberError();
            } else if (event.target.fieldName === 'Cvv') {
              setCvvError();
              setCvvError(getTranslatedString('tenantPortal.paysafe.invalidCVVNumber'));
            } else if (event.target.fieldName === 'ExpiryDate') {
              setExpiryDateError();
              setExpiryDateError(getTranslatedString('tenantPortal.paysafe.invalidDate'));
            }
          });
        }
      });
    },
    [setPaysafeInstance, setCardNumberError, setCvvError, setExpiryDateError]
  );

  return (
    <div>
      <div id="card-number" style={style.base} />
      {cardNumberError && <StyledErrorP>{cardNumberError}</StyledErrorP>}

      <div id="cvv" style={style.base} />
      {cvvError && <StyledErrorP>{cvvError}</StyledErrorP>}

      <div id="expiration-date" style={style.base} />
      {expiryDateError && <StyledErrorP>{expiryDateError}</StyledErrorP>}
    </div>
  );
};
